import type { App } from 'vue';

export default (app: App) => {
  app.directive('focus', {
    /**
     * inserted
     * @param el ...
     * @param binding ..
     */
    mounted: function (el, binding) {
      if (binding.value != false) {
        el.focus();
      }
    },
  });
};
